import { hideAndRemove } from "../../changeObjectParams/helpers";
import { cloneObject } from "../../cloneObject";

export default [
    {
        key: "verstak__tumba",
        position: "bottom",
        extra: function (el) {
            const rightTumba = cloneObject(el);
            rightTumba.scale.x = -1; // Отзеркаливаем по оси X
            rightTumba.name = el.name + "__right"; // Присваиваем имя

            const leftKey_R = rightTumba.children.find((item) => item.name.includes("key_left"));
            const leftArm_R = rightTumba.children.find((item) => item.name.includes("arm_right"));
            hideAndRemove(leftKey_R);
            hideAndRemove(leftArm_R);
            rightTumba.userData.allFolderName = "allVerstakTumbaRight";
            rightTumba.userData.activeFolderName = "activeVerstakTumbaRight";
            rightTumba.userData.position = this.position;
            rightTumba.userData.isBottom = this.position === "bottom";
            servObj.allVerstakTumbaRight.push(rightTumba);
            const leftTumba = el;
            leftTumba.name = el.name + "__left";
            const rightKey_L = leftTumba.children.find((item) => item.name.includes("key_right"));
            const rightArm_L = leftTumba.children.find((item) => item.name.includes("arm_left"));
            hideAndRemove(rightKey_L);
            hideAndRemove(rightArm_L);
            leftTumba.userData.allFolderName = "allVerstakTumbaLeft";
            leftTumba.userData.activeFolderName = "activeVerstakTumbaLeft";
            leftTumba.userData.position = this.position;
            leftTumba.userData.isBottom = this.position === "bottom";
            servObj.allVerstakTumbaLeft.push(leftTumba);
        },
    },
    {
        key: "verstak__nozhki",
        position: "bottom",
        extra: function (el) {
            const rightNozhka = cloneObject(el);
            rightNozhka.scale.x = -1;
            rightNozhka.name = el.name + "__right";
            rightNozhka.userData.allFolderName = "allVerstakNozhkiRight";
            rightNozhka.userData.activeFolderName = "activeVerstakNozhkiRight";
            rightNozhka.userData.position = this.position;
            rightNozhka.userData.isBottom = this.position === "bottom";
            servObj.allVerstakNozhkiRight.push(rightNozhka);
            const leftTumba = el;
            leftTumba.name = el.name + "__left";
            leftTumba.userData.allFolderName = "allVerstakNozhkiLeft";
            leftTumba.userData.activeFolderName = "activeVerstakNozhkiLeft";
            leftTumba.userData.position = this.position;
            leftTumba.userData.isBottom = this.position === "bottom";
            servObj.allVerstakNozhkiLeft.push(leftTumba);
        },
    },
    {
        key: "perekladini",
        allArray: "allVerstakPerekladini",
        activeArray: "activeVerstakPerekladini",
        position: "bottom",
    },
];
